import { ChartData } from 'chart.js'

/**
 * An empty plot, with y-axis labels set to the years to display and all data values set to 0.
 */
export function getEmptyPlot(
  yearsToDisplay: number[]
): ChartData<'bar', number[]> {
  return {
    labels: yearsToDisplay.map((year) => year.toString()),
    datasets: [
      {
        data: yearsToDisplay.map(() => 0),
        label: '',
      },
    ],
  }
}
